<template>
  <div
    class="modal modal-slide overflow-hidden fade"
    :id="idModal"
    role="dialog"
  >
    <!-- bottom-0 m-0 p-0 position-fixed -->
    <div class="d-flex justify-content-center w-100">
      <div class="modal-dialog m-0 bottom-0 modal-lg position-fixed w-100">
        <div class="bottom-0 position-sticky bg-modal">
          <div class="modal-content border-0">
            <div class="p-x-20 modal-header d-flex padding-header">
              <template v-if="btnBack">
                <button class="btn img-back" @click="back">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.5893 3.57757C10.9147 3.90301 10.9147 4.43065 10.5893 4.75609L6.17855 9.16683H15.8334C16.2936 9.16683 16.6667 9.53993 16.6667 10.0002C16.6667 10.4604 16.2936 10.8335 15.8334 10.8335H6.17855L10.5893 15.2442C10.9147 15.5697 10.9147 16.0973 10.5893 16.4228C10.2639 16.7482 9.73622 16.7482 9.41079 16.4228L3.57745 10.5894C3.25201 10.264 3.25201 9.73634 3.57745 9.41091L9.41079 3.57757C9.73622 3.25214 10.2639 3.25214 10.5893 3.57757Z"
                      fill="#206CFE"
                    />
                  </svg>
                </button>
              </template>
              <p
                class="m-0 f-Overpass f-w-600 f-16 w-100 text-center f-c-black"
                :class="btnBack ? '' : 'header-text '"
              >
                {{ modalTitle }}
              </p>
              <button class="btn" @click="close">
                <img
                  src="../../assets/icons/buttonClose.svg"
                  class="img-close"
                />
              </button>
            </div>
            <div class="modal-body p-0 height-modal">
              <slot name="modal-content"></slot>
            </div>
            <div class="modal-footer p-0" v-if="footer">
              <slot name="modal-footer"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bootstrapBundleMin from "bootstrap/dist/js/bootstrap.bundle.min";

export default {
  name: "slotModal",
  props: {
    idModal: String,
    modalTitle: String,
    footer: Boolean,
    btnBack: Boolean,

    // value ini akan mengambil nilai dari component yang memanggil modal , dengan menggunakan v-model
    value: Boolean,
  },
  data() {
    return {
      myModal: null,
    };
  },
  mounted() {
    // alert("ini mounted");
    this.myModal = new bootstrapBundleMin.Modal(`#${this.idModal}`, {
      keyboard: false,
    });
    this.listenModal();
  },
  watch: {
    value(v) {
      // alert(this.values + " ini nilai values di awal awal");
      // alert("ini di watch " + v);
      if (v == true) {
        const IdModal = document.getElementById(this.idModal);
        this.myModal.show(IdModal);
        // alert("isi modalToggle " + modalToggle);
        // alert("open");
      }
      if (v == false) {
        this.$emit("close");
        const IdModal = document.getElementById(this.idModal);
        this.myModal.hide(IdModal);
        // alert("close");
        // jika ingin yakin bahwa modal tertutup dengan baik , nyalakan alert tersebut
      }
    },
  },
  methods: {
    // ini fuction untuk menutup modal dengan backdrop, atau diluar lingkup modal
    listenModal() {
      // alert("ini di listen modal");
      const myModalId = document.getElementById(this.idModal);
      myModalId.addEventListener("hidden.bs.modal", () => {
        this.$emit("input", false); // aku belum tahu dengan fungsi ini, tetapi fungsi ini dapat mengubah v atau dialog menjadi false
      });
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.bg-modal {
  background-color: #ffff;
  border-radius: 16px 16px 0px 0px;
}
.modal-slide {
  animation: slide-up 0.3s;
}
.padding-header {
  padding: 10px 0px 10px 0px;
}
.img-close {
  padding-right: 16px;
}
.img-back {
  padding-left: 16px;
}
.header-text {
  padding-left: 45px;
}
.height-modal {
  max-height: 60vh;
  overflow: scroll;
}

@keyframes slide-up {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0%);
  }
}
</style>
